// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"203":"335cb7e3","374":"3fc3c9ec","478":"15ceb54f","659":"26385973"}[chunkId] + ".chunk.css";
};